var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7489 6.60539C12.0837 6.27055 12.0837 5.72677 11.7489 5.39193L7.46292 1.10598C7.12808 0.771137 6.5843 0.771137 6.24946 1.10598C5.91462 1.44082 5.91462 1.9846 6.24946 2.31944L9.07551 5.14281H0.857191C0.383057 5.14281 0 5.52587 0 6C0 6.47413 0.383057 6.85719 0.857191 6.85719H9.07283L6.25213 9.68056C5.91729 10.0154 5.91729 10.5592 6.25213 10.894C6.58697 11.2289 7.13076 11.2289 7.4656 10.894L11.7515 6.60807L11.7489 6.60539Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.8509a9d7065c9fccc9b4ab3b005ca9c4.svg";
export { ForwardRef as ReactComponent };